import React from "react";
import Header from "../../components/Header/Header";
import { Fade } from "react-awesome-reveal";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import "./OurTeam.css";
import Button from "../../components/Button/Button";
import { useResponsive } from "../../shared/hooks/useResponsive";

const MobileView = ({ theme }: any) => {
  return (
    <div className="contact-main">
      <div className="BackgroundHome"> </div>
      <Header theme={theme} />
      <div className="basic-contact">
        <Fade duration={1000}>
          <div style={{ marginBottom: "2rem" }} className="contact-heading-div">
            <div className="contact-heading-img-div">
              <img
                src={require(`../../assets/images/nishan.jpg`)}
                alt=""
                style={{
                  borderRadius: "50%",
                  width: "80%",
                  border: "4px solid #1193EF",
                  padding: 4,
                }}
              />
            </div>
            <div className="contact-heading-text-div">
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                Nishankar Sathiyamohan
              </h1>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                Reach out to contact info on my resume, and I'll be sure to
                respond within 24 hours. Let's collaborate and explore the
                realms of ML, AI, React, Android, Cloud, and Opensource
                Development together.
              </p>
              <div className="resume-btn-div">
                <Button
                  text="See My Resume"
                  newTab={true}
                  href="https://firebasestorage.googleapis.com/v0/b/codinglerds.appspot.com/o/Nishankar_CV.pdf?alt=media&token=2385dfc0-d3a4-49ed-9519-3ab00172a32a"
                  theme={theme}
                />
              </div>
            </div>
          </div>
        </Fade>
        <Fade duration={1000}>
          <div className="contact-heading-div">
            <div className="contact-heading-img-div">
              <img
                src={require(`../../assets/images/person.jpg`)}
                alt=""
                style={{
                  borderRadius: "50%",
                  width: "80%",
                  border: "4px solid #1193EF",
                  padding: 4,
                }}
              />
            </div>
            <div className="contact-heading-text-div">
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                Kirsnaragavan Arudpiragasam
              </h1>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                Reach out to contact info on my resume, and I'll be sure to
                respond within 24 hours. Let's collaborate and explore the
                realms of ML, AI, React, Android, Cloud, and Opensource
                Development together.
              </p>
              <div className="resume-btn-div">
                <Button
                  text="See My Resume"
                  newTab={true}
                  theme={theme}
                  href="https://firebasestorage.googleapis.com/v0/b/codinglerds.appspot.com/o/Kirsnaragavan'S%20_CV.pdf?alt=media&token=e30ebce5-820e-4c42-a395-4e92b5e92115"
                />
              </div>
            </div>
          </div>
        </Fade>
        <Fade duration={1000}>
          <div style={{ marginTop: "2rem" }} className="contact-heading-div">
            <div className="contact-heading-img-div">
              <img
                src={require(`../../assets/images/person2.jpg`)}
                alt=""
                style={{
                  borderRadius: "50%",
                  width: "80%",
                  border: "4px solid #1193EF",
                  padding: 4,
                }}
              />
            </div>
            <div className="contact-heading-text-div">
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                Piriyaraj Sivagnanasuntharam
              </h1>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                Reach out to contact info on my resume, and I'll be sure to
                respond within 24 hours. Let's collaborate and explore the
                realms of ML, AI, React, Android, Cloud, and Opensource
                Development together.
              </p>
              <div className="resume-btn-div">
                <Button
                  text="See My Resume"
                  newTab={true}
                  theme={theme}
                  href="https://firebasestorage.googleapis.com/v0/b/codinglerds.appspot.com/o/PIRIYARAJ%20CV-230308-151425.pdf?alt=media&token=b604d4e9-b6ba-4c4f-a301-ed0aca29fdf6"
                />
              </div>
            </div>
          </div>
        </Fade>
      </div>

      <Footer theme={theme} />
      <TopButton theme={theme} />
    </div>
  );
};

const DesktopView = ({ theme }: any) => {
  return (
    <div className="contact-main">
      <div className="BackgroundHome"></div>
      <Header theme={theme} />
      <div className="basic-contact">
        <Fade duration={1000}>
          <div style={{ marginTop: "2rem" }} className="contact-heading-div">
            <div className="contact-heading-img-div">
              <img
                src={require(`../../assets/images/nishan.jpg`)}
                alt=""
                style={{
                  borderRadius: "50%",
                  width: "80%",
                  border: "4px solid #1193EF",
                  padding: 4,
                }}
              />
            </div>
            <div className="contact-heading-text-div">
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                Nishankar Sathiyamohan
              </h1>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                Reach out to contact info on my resume, and I'll be sure to
                respond within 24 hours. Let's collaborate and explore the
                realms of ML, AI, React, Android, Cloud, and Opensource
                Development together.
              </p>
              <div className="resume-btn-div">
                <Button
                  text="See My Resume"
                  newTab={true}
                  theme={theme}
                  href="https://firebasestorage.googleapis.com/v0/b/codinglerds.appspot.com/o/Nishankar_CV.pdf?alt=media&token=2385dfc0-d3a4-49ed-9519-3ab00172a32a"
                />
              </div>
            </div>
          </div>
        </Fade>
        <Fade duration={1000}>
          <div className="contact-heading-div">
            <div className="contact-heading-text-div">
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                Kirsnaragavan Arudpiragasam
              </h1>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                Reach out to contact info on my resume, and I'll be sure to
                respond within 24 hours. Let's collaborate and explore the
                realms of ML, AI, React, Android, Cloud, and Opensource
                Development together.
              </p>
              <div className="resume-btn-div">
                <Button
                  text="See My Resume"
                  newTab={true}
                  theme={theme}
                  href="https://firebasestorage.googleapis.com/v0/b/codinglerds.appspot.com/o/Kirsnaragavan'S%20_CV.pdf?alt=media&token=e30ebce5-820e-4c42-a395-4e92b5e92115"
                />
              </div>
            </div>
            <div className="contact-heading-img-div">
              <img
                src={require(`../../assets/images/person.jpg`)}
                alt=""
                style={{
                  borderRadius: "50%",
                  width: "80%",
                  border: "4px solid #1193EF",
                  padding: 4,
                }}
              />
            </div>
          </div>
        </Fade>
        <Fade duration={1000}>
          <div style={{ marginTop: "2rem" }} className="contact-heading-div">
            <div className="contact-heading-img-div">
              <img
                src={require(`../../assets/images/person2.jpg`)}
                alt=""
                style={{
                  borderRadius: "50%",
                  width: "80%",
                  border: "4px solid #1193EF",
                  padding: 4,
                }}
              />
            </div>
            <div className="contact-heading-text-div">
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                Piriyaraj Sivagnanasuntharam
              </h1>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                Reach out to contact info on my resume, and I'll be sure to
                respond within 24 hours. Let's collaborate and explore the
                realms of ML, AI, React, Android, Cloud, and Opensource
                Development together.
              </p>
              <div className="resume-btn-div">
                <Button
                  text="See My Resume"
                  newTab={true}
                  theme={theme}
                  href="https://firebasestorage.googleapis.com/v0/b/codinglerds.appspot.com/o/PIRIYARAJ%20CV-230308-151425.pdf?alt=media&token=b604d4e9-b6ba-4c4f-a301-ed0aca29fdf6"
                />
              </div>
            </div>
          </div>
        </Fade>
      </div>

      <Footer theme={theme} />
      <TopButton theme={theme} />
    </div>
  );
};

export default function OurTeam(props: any) {
  const { isTablet, isMobile } = useResponsive();
  const theme = props.theme;
  return !isTablet ? (
    <MobileView theme={theme} />
  ) : (
    <DesktopView theme={theme} />
  );
}
